import { Check, Lock } from "lucide-react";
import { api } from "@/lib/api";

export const INCLUDED = [
  "One main storyteller and up to 6 people receiving a message",
  "One personal message from the storyteller to each person, and one reply back from each of them",
  "Up to 12 recordings in total, each between 1 and 4 minutes",
  "Private invitation links by email or WhatsApp — family reply free, with no account needed",
  "Choose the playback order, preview it, then create one joined audio keepsake from your original recordings",
  "Download your keepsake as an MP3, and keep every original recording",
  "Private by default — only you and the people you invite can listen",
];

export const EXTENSION_TEXT = "Adds 6 more recipients and 12 more recordings — up to 12 recipients and 24 recordings in total.";

export const gbp = (pence) => `£${(pence / 100).toFixed(2)}`;

export async function startCheckout(items = ["base"]) {
  const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin, items });
  window.location.assign(data.checkout_url);
}

export function ExtensionOption({ checked, onChange, testid = "extension-option" }) {
  return (
    <label className="flex gap-3 items-start rounded-xl border border-[rgba(139,44,255,0.35)] bg-[#1A1222] p-4 cursor-pointer" data-testid={testid}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="mt-1 h-5 w-5 accent-[#8B2CFF]" data-testid={`${testid}-checkbox`} />
      <span>
        <span className="block text-[#EDE6F7] text-lg font-semibold">Add six more people <span className="text-[#B57BFF]">+£4.99</span></span>
        <span className="block text-sm text-[#B9B3C8] leading-relaxed">{EXTENSION_TEXT}</span>
      </span>
    </label>
  );
}

export function StoryComingSoon() {
  return (
    <div className="rounded-xl border border-[rgba(139,111,176,0.45)] bg-[#1E1428] p-4" data-testid="story-upgrade-coming-soon">
      <p className="text-[#EDE6F7] font-semibold">Turn your memories into a narrated story <span className="text-[#C9B6E4]">+£9.99 · coming soon</span></p>
      <p className="text-sm text-[#B9B3C8] mt-1 leading-relaxed">
        A family tree, an AI-edited story you review and approve, and narration in AI-recreated voices — only with each
        speaker's own consent. Not yet available to buy.
      </p>
    </div>
  );
}

export function PurchaseCard({ extension, onExtension }) {
  const total = 999 + (extension ? 499 : 0);
  return (
    <aside className="glass-card p-7 sm:p-9 h-full" data-testid="purchase-card" aria-labelledby="purchase-title">
      <p id="purchase-title" className="font-serif text-xl sm:text-2xl tracking-[0.14em] text-[#EDE6F7]" data-testid="purchase-brand">MEMORIES FOREVER</p>
      <p className="font-cormorant italic text-xl text-[#B57BFF] mb-6" data-testid="purchase-slogan">The Voices We Love.</p>
      <span className="font-serif text-5xl sm:text-6xl text-[#EDE6F7]" data-testid="purchase-price">£9.99</span>
      <p className="mt-2 text-lg text-[#B57BFF]" data-testid="purchase-terms">One-off purchase. No subscription.</p>
      <div className="gold-line my-6" />
      <p className="eyebrow mb-3">The original keepsake includes</p>
      <ul className="space-y-3" data-testid="purchase-included">
        {INCLUDED.map((t) => (
          <li key={t} className="flex gap-3 text-[#D2CBE0] leading-relaxed">
            <Check className="h-5 w-5 mt-1 shrink-0 text-[#B57BFF]" aria-hidden="true" />
            <span>{t}</span>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-sm text-[#8C84A0]">You don't have to use all six spaces — 12 recordings is the full allowance.</p>
      {onExtension && <div className="mt-6"><ExtensionOption checked={extension} onChange={onExtension} /></div>}
      <div className="mt-4"><StoryComingSoon /></div>
      {onExtension && (
        <p className="mt-6 text-xl text-[#EDE6F7]" data-testid="purchase-total">Total today: <strong>{gbp(total)}</strong></p>
      )}
      <p className="mt-6 flex gap-2 text-sm text-[#A49CB8] leading-relaxed" data-testid="purchase-note">
        <Lock className="h-4 w-4 mt-0.5 shrink-0 text-[#B57BFF]" aria-hidden="true" />
        Creating an account doesn't complete your purchase. You'll pay securely with Stripe on the next step, and
        you'll only be charged once.
      </p>
    </aside>
  );
}
